import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "store";
// import { useWindowDimensions } from "resources/BrowserManager";
import strings from "resources/strings";
import CONSTANTS from "../../../shared/constants";
import TableEFOS from "../components/TableEFOS";
import {
  Typography,
  Flex,
  Space,
  Button,
  Card,
  Tooltip,
  message,
  theme,
} from "antd";
const { Title, Text } = Typography;

import {
  CrownFilled,
  Loading3QuartersOutlined,
  LinkOutlined,
  CheckCircleOutlined,
  InfoCircleFilled,
} from "@ant-design/icons";

import ApiManager from "resources/ApiManager/api";

import "./style.scss";
const styleWrapperClass = "efos";

const NoEfosLinks = () => {
  const { token: theme_token } = theme.useToken();

  return (
    <Card>
      <Flex vertical justify="center" gap={15}>
        <Flex justify="center">
          <CheckCircleOutlined
            style={{
              fontSize: "100px",
              color: theme_token.colorPrimary,
            }}
          />
        </Flex>

        <Flex vertical justify="center" gap={0}>
          <Text
            strong
            style={{
              fontSize: "18px",
              textAlign: "center",
            }}
          >
            ¡No se han detectado CFDIs relacionados con EFOS!
          </Text>

          <Text
            style={{
              fontSize: "15px",
              textAlign: "center",
            }}
          >
            Se realizará la revisión de CFDIs nuevos de acuerdo a tu horario de
            actualización.
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
};

const EFOSConfig = ({ active_rfc_obj }) => {
  const { token: theme_token } = theme.useToken();

  const [isUpdatingData, setisUpdatingData] = useState(true);
  const [efosLinksFirstPage, setEfosLinksFirstPage] = useState([]);
  const [efosLinksPaginationToken, setEfosLinksPaginationToken] = useState([]);

  const rfc = active_rfc_obj?.rfc;

  useEffect(() => {
    if (!rfc) return;

    let cancelled = false;
    setisUpdatingData(true);

    const fetchLinks = async () => {
      const apiRes = await ApiManager.getUserRfcEfosLinks(rfc);
      if (cancelled) return;

      //Silently return when error was for session expired, as the api handler will handle the message and redirection to /login
      if (
        apiRes.response.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED
      ) {
        return;
      }

      if (apiRes.response.code !== 2000) {
        message.error(strings.alertUnexpectedError);
        setisUpdatingData(false);
        return;
      }

      setEfosLinksFirstPage(apiRes.data.efos_links);
      setEfosLinksPaginationToken(apiRes.data.pagination_token);
      setisUpdatingData(false);
    };

    fetchLinks();

    return () => {
      cancelled = true;
    };
  }, [rfc]);

  return (
    <>
      <Title level={4}>
        Monitorea tu actividad de CFDIs relacionados con Empresas que Facturan
        Operaciones Simuladas (EFOS).
        <Tooltip
          placement="bottomLeft"
          title={
            <>
              <Text style={{ color: "white" }}>
                Las EFOS son empresas o personas que han sido identificadas por
                las autoridades fiscales como emisoras de facturas falsas o
                simuladas. Estas suelen estar involucradas en actividades
                fraudulentas para evadir impuestos o lavar dinero. Para más
                información, haz click{" "}
                <a
                  href={CONSTANTS.SAT_EFOS_INFO_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "white", textDecoration: "underline" }}
                >
                  aquí
                </a>
                .
              </Text>
            </>
          }
        >
          <InfoCircleFilled
            style={{
              color: theme_token.colorSecondary,
              cursor: "help",
              marginLeft: "5px",
              fontSize: "16px",
            }}
          />
        </Tooltip>
      </Title>
      <Flex style={{ marginTop: "30px" }} vertical gap={30}>
        {isUpdatingData && (
          <Flex justify="center">
            <Loading3QuartersOutlined
              spin={true}
              style={{
                fontSize: "20px",
                marginTop: "50px",
                color: theme_token.colorSecondary,
              }}
            />
          </Flex>
        )}

        {!isUpdatingData &&
          (efosLinksFirstPage.length > 0 ? (
            <TableEFOS
              efosLinksFirstPage={efosLinksFirstPage}
              efosLinksPaginationToken={efosLinksPaginationToken}
            />
          ) : (
            <NoEfosLinks />
          ))}
      </Flex>
    </>
  );
};

const BannerFeatureNotAvailable = () => {
  const navigate = useNavigate();

  return (
    <Space
      style={{
        marginTop: "20px",
        marginBottom: "20px",
        width: "100%",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Space direction="vertical">
        <Title level={3}>
          Disponible en el plan <CrownFilled className="fg-gold" /> Pro ó Básico
        </Title>
        <Title level={5}>
          Para recibir alertas y ver información de CFDIs relacionados con EFOS,
          deberás subscribirte al plan <CrownFilled className="fg-gold" /> Pro ó
          Básico.
        </Title>
        <Button onClick={() => navigate("/plan")}>Ver Planes</Button>
      </Space>
    </Space>
  );
};

export default function EFOS() {
  // const { isSmallView } = useWindowDimensions();

  const user = useStore((state) => state.user);
  const activeRfc = useStore((state) => state.activeRfc);

  const active_rfc_obj = user.rfcs[activeRfc];

  return (
    <div className={styleWrapperClass}>
      <Title level={1}>EFOS</Title>
      {active_rfc_obj?.plan_name === "free" ? (
        <BannerFeatureNotAvailable />
      ) : active_rfc_obj ? (
        <EFOSConfig active_rfc_obj={active_rfc_obj} />
      ) : null}
    </div>
  );
}
